export default __webpack_public_path__ + "static/solar-circle-7df6c39173e9e00de77ceb8d6587b591.png";